export default __webpack_public_path__ + "static/media/medKnotLeftBottom.51c72cb9.png";